// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__AQsyL","container":"styles_container__-gfym","item":"styles_item__4R1Lg","app":"styles_app__ltNcn"};